var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 13H9.50003V22H23.5V13Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.75C17.1904 18.75 17.75 18.1904 17.75 17.5C17.75 16.8096 17.1904 16.25 16.5 16.25C15.8097 16.25 15.25 16.8096 15.25 17.5C15.25 18.1904 15.8097 18.75 16.5 18.75Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13V9C20.5 7.93913 20.0786 6.92172 19.3285 6.17157C18.5783 5.42143 17.5609 5 16.5 5C15.4392 5 14.4217 5.42143 13.6716 6.17157C12.9215 6.92172 12.5 7.93913 12.5 9V13",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 28C12.3285 28 13 27.3284 13 26.5C13 25.6716 12.3285 25 11.5 25C10.6716 25 10 25.6716 10 26.5C10 27.3284 10.6716 28 11.5 28Z",
    fill: "#161616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28C17.3285 28 18 27.3284 18 26.5C18 25.6716 17.3285 25 16.5 25C15.6716 25 15 25.6716 15 26.5C15 27.3284 15.6716 28 16.5 28Z",
    fill: "#161616"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 28C22.3285 28 23 27.3284 23 26.5C23 25.6716 22.3285 25 21.5 25C20.6716 25 20 25.6716 20 26.5C20 27.3284 20.6716 28 21.5 28Z",
    fill: "#161616"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 28C27.3285 28 28 27.3284 28 26.5C28 25.6716 27.3285 25 26.5 25C25.6716 25 25 25.6716 25 26.5C25 27.3284 25.6716 28 26.5 28Z",
    fill: "#161616"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50003 28C7.32846 28 8.00003 27.3284 8.00003 26.5C8.00003 25.6716 7.32846 25 6.50003 25C5.6716 25 5.00003 25.6716 5.00003 26.5C5.00003 27.3284 5.6716 28 6.50003 28Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.f6b04506b580f4382be623193404a9c7.svg";
export { ForwardRef as ReactComponent };